<template>
	<div>
		<v-btn color="success" class="add-offer-popup-btn-success"
			@click="addOfferVisible = true"
			v-if="legalFormMembership"
		>
			<v-icon class="mr-2 white--text">add</v-icon>
			Rozpocznij składanie nowej oferty
		</v-btn>
		<v-dialog
			v-model="addOfferVisible"
			max-width="1000px"
		>
			<v-card>
				<v-toolbar>
					<v-toolbar-title>Składanie nowej oferty</v-toolbar-title>
				</v-toolbar>
				<v-form ref="form">
					<v-container fluid>
						<v-layout mt-3 v-if="roles.isSubBidder() && subbiderType === 'COWORKER'">
							<v-flex xs1/>
							<v-flex xs10>
								<div>
									<v-alert :value="true" type="warning">
										Oferta będzie mogła zostać przekazana do edycji innej osobie dopiero po zaopiniowaniu przez konto nadrzędne. Aby edycja oferty mogła być przekazywana od momentu jej utworzenia, ofertę musi utworzyć użytkownik konta nadrzędnego.
									</v-alert>
								</div>
							</v-flex>
							<v-flex xs1/>
						</v-layout>
						<v-layout mt-3>
							<v-flex xs1/>
							<v-flex xs10>
								<egranty-text-input-field
									v-model="offerName"
									label="Tytuł oferty"
									for="add-offer-popup-offer-name"
									id="add-offer-popup-offer-name"
								></egranty-text-input-field>
							</v-flex>
							<v-flex xs1/>
						</v-layout>
						<div v-if="options.modularOfferSettings.modularOffersEnabled">
							<v-layout row>
								<v-flex xs1/>
								<v-flex xs10>
									<v-layout mb-3 v-if="options.modularOfferSettings.modularOffersAnnouncement">
										{{options.modularOfferSettings.modularOffersAnnouncement}}
									</v-layout>
								</v-flex>
								<v-flex xs1/>
							</v-layout>
							<v-layout row>
								<v-flex xs1/>
								<v-flex xs3>
									<v-select
										v-model="chosenCount"
										:items="countPossibilities"
										label="Liczba modułów"
										aria-label="modules number"
										for="add-offer-popup-offer-number-modules"
										id="add-offer-popup-offer-number-modules"
										@input="error=''"
									></v-select>
								</v-flex>
								<v-flex x8/>
							</v-layout>
							<v-layout v-if="error!==''">
								<v-flex xs1/>
								<v-flex xs10>
									<div style="color:rgb(255, 23, 68);">
										{{error}}
									</div>
								</v-flex>
								<v-flex xs1/>
							</v-layout>
						</div>
					</v-container>
				</v-form>
				<v-layout>
					<v-spacer/>
					<v-btn class="add-offer-popup-btn primary" @click="send">
						Zapisz i rozpocznij wypełnianie
					</v-btn>
				</v-layout>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import {PublicContest} from "@/api/generated/PublicContest";
	import {Offer} from "@/api/generated/Offer";
	import {User} from "@/api/generated/User";
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";

	export default {
		name: "AddOfferPopup",

		components: {EgrantyTextInputField},

		props: {
			legalFormMembership: Boolean,
		},

		methods: {
			send() {
				if (!this.$refs.form.validate()) {
					return;
				}
				if (this.options.modularOfferSettings.modularOffersEnabled && isNaN(parseInt(this.chosenCount))) {
					this.error = "Proszę podać liczbę modułów";
					return;
				}
				let offerData = {};
				offerData.contestId = this.contestData.id;
				offerData.modulesRealizationId = null;
				offerData.title = this.offerName;
				offerData.englishTitle = this.englishOfferName;
				offerData.otherBiddersId = this.selectedBidders;
				for (let i in this.options.modularOfferSettings.possibleModulesCount) {
					if (this.options.modularOfferSettings.possibleModulesCount[i].count === this.chosenCount) {
						offerData.modulesRealizationId = this.options.modularOfferSettings.possibleModulesCount[i].id;
					}
				}
				Offer.post(
					this,
					offerData,
					response => {
						this.$router.push("/app/contest/" + this.contestData.id + "/place-offer/" + response);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message);
					}
				);
			},
			
			loadSubbiderType() {
				if (this.roles.isSubBidder()) {
					User.getUserSubbiderType(this,
						response => {
							this.subbiderType = response;
						}
					);
				}
			},
		},

		created() {
			loadTasks(this);
			this.loadSubbiderType();
		},

		data() {
			return {
				contestData: {
					id: this.$route.params.id,
				},
				possibleCounts: [],
				addOfferVisible: false,
				options: {
					modularOfferSettings: {
						modularOffersEnabled: false,
					},
				},
				possibleBidders: [],
				selectedBidders: [],
				chosenCount: "",
				offerName: "",
				englishOfferName: "",
				error: "",
				subbiderType: null,
			};
		},

		computed: {
			countPossibilities() {
				return this.possibleCounts.map(possibility => {
					return possibility.count;
				});
			},
		},
	};

	function loadTasks(ctx) {
		PublicContest.getGeneralSettings(ctx, ctx.contestData.id,
			response => {
				ctx.options = response;
				ctx.possibleCounts = [];
				for (let i in response.modularOfferSettings.possibleModulesCount) {
					ctx.possibleCounts.push(response.modularOfferSettings.possibleModulesCount[i]);
				}
			},
		);
	}
</script>

<style scoped>
	.add-offer-popup-btn {
		background-color: #f5f5f5;
		margin-left: 20px;
    margin-right: 60px;
		margin-bottom: 20px;
	}
	.add-offer-popup-btn-success {
		margin-top: 20px;
	}

	.add-offer-popup-btn-success[data-v-172b0ff2] {
		margin-top: 10px;
	}

</style>
